import React, { useEffect } from 'react'
import { FormContext, useForm } from 'react-hook-form'
import { Card, CardActions, CardContent, FontIcon, Grid } from 'react-md'

import { Cell, PageTitle, ButtonSuccess } from 'components/core'
import { handleSubmit, Input } from 'components/form'
import { ProfileSelect } from 'components/select'

import { defaultValues, validationSchema } from './config'
import { handleSave } from './actions'

const Component: React.FC = () => {
  const form = useForm({ defaultValues })

  useEffect(() => {
    document.title = 'Novo Usuário'
  }, [])

  return (
    <Grid>
      <Cell>
        <PageTitle title='Novo Usuário' />
        <Card fullWidth>
          <CardContent>
            <FormContext {...form}>
              <Grid>
                <Input name='name' label='Nome *' desktopSize={6} tabletSize={4} />
                <Input name='email' label='Email *' desktopSize={6} tabletSize={4} />
              </Grid>
              <Grid>
                <Input name='login' label='Login *' desktopSize={6} tabletSize={4} />
                <ProfileSelect name='profileId' label='Perfil *' desktopSize={6} tabletSize={4} />
              </Grid>
              <Grid>
                <Input name='password' label='Senha *' type='password' desktopSize={6} tabletSize={4} />
                <Input name='confirmPassword' label='Confirmação de Senha *' type='password' desktopSize={6} tabletSize={4} />
              </Grid>
            </FormContext>
          </CardContent>
          <CardActions>
            <ButtonSuccess
              text='Salvar'
              icon={<FontIcon>done</FontIcon>}
              disabled={!form.formState.dirty}
              onClick={async () =>
                await handleSubmit(form, validationSchema, async () => {
                  if (await handleSave(form.getValues())) form.reset(defaultValues, { dirty: false })
                })
              }
            />
          </CardActions>
        </Card>
      </Cell>
    </Grid>
  )
}

export default Component
